"use strict";

exports.__esModule = true;
exports.IconArrowTop = exports.IconArrowLeft = void 0;
var IconArrowTop = "<svg\n      width=\"37\"\n      height=\"19\"\n      viewBox=\"0 0 37 19\"\n      fill=\"none\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n    >\n      <path d=\"M18.5 0L0 18.5H37L18.5 0Z\" fill=\"#E3E5E6\" />\n    </svg>";

// svg pointing left
exports.IconArrowTop = IconArrowTop;
var IconArrowLeft = "<svg\nwidth=\"37\"\nheight=\"19\"\nviewBox=\"0 0 37 19\"\nfill=\"none\"\nxmlns=\"http://www.w3.org/2000/svg\"\n>\n<path d=\"M9.5 9.5L19 0L19 19Z\" fill=\"#E3E5E6\" />\n</svg>";
exports.IconArrowLeft = IconArrowLeft;